/** Advisory hints only: browser-owned password and security prompts remain device settings. */
export const operatorSecretInputAttributes = {
  autoComplete: "off",
  autoCapitalize: "none",
  autoCorrect: "off",
  spellCheck: false,
  "data-1p-ignore": true,
  "data-lpignore": "true",
  "data-bwignore": true,
} as const;

/** Scoped to the operator shell; restore the page when switching to another role. */
export function applyOperatorBrowserPolicy(page: Document, browser: Window) {
  const previousTranslate = page.documentElement.getAttribute("translate");
  page.documentElement.setAttribute("translate", "no");
  const previousMeta = page.querySelector<HTMLMetaElement>('meta[name="google"]');
  const meta = previousMeta ?? page.createElement("meta");
  const previousContent = meta.getAttribute("content");
  meta.name = "google";
  meta.content = "notranslate";
  if (!previousMeta) page.head.append(meta);
  const preventInstallSuggestion = (event: Event) => event.preventDefault();
  browser.addEventListener("beforeinstallprompt", preventInstallSuggestion);
  return () => {
    browser.removeEventListener("beforeinstallprompt", preventInstallSuggestion);
    if (page.documentElement.getAttribute("translate") === "no") {
      if (previousTranslate === null) page.documentElement.removeAttribute("translate");
      else page.documentElement.setAttribute("translate", previousTranslate);
    }
    if (meta.content !== "notranslate") return;
    if (!previousMeta) meta.remove();
    else if (previousContent === null) meta.removeAttribute("content");
    else meta.setAttribute("content", previousContent);
  };
}
